import { ReactNode } from "react";
import { MemeGeneratorState } from "store/features/memeGenerator/types";

interface ItemsContainerProps {
    children: ReactNode;
    settings: NonNullable<MemeGeneratorState["meme"]>["settings"];
    template: NonNullable<MemeGeneratorState["meme"]>["template"];
}

export const ItemsContainer = ({ children, settings, template }: ItemsContainerProps) => {
    return (
        <div
            className="absolute z-10"
            style={{
                position: "absolute",
                left: settings.image.left,
                top: settings.image.top,
                width: settings.image.width,
                height: settings.image.height,
            }}
        >
            <img
                key={template.imageUrl}
                src={template.imageUrl}
                width={settings.image.width}
                height={settings.image.height}
                alt={template.description}
                style={{
                    width: settings.image.width,
                    height: settings.image.height,
                }}
                draggable={false}
            />
            {children}
        </div>
    );
};
